'use client';

// import type { FieldAttributes, FieldProps } from 'formik';
import { useState } from 'react';
import { Formik, Form, Field, FormikHelpers } from 'formik';
import { object, string } from 'yup';

interface NewsletterFormValues {
  base: string; // used for global error messages
  email: string;
}

interface NewsletterResultSuccess {
  success: boolean;
}

interface NewsletterResultError {
  error: {
    title: string;
    message: string;
  };
}

type NewsletterResult = NewsletterResultSuccess | NewsletterResultError;

const NewsletterSchema = object().shape({
  email: string().email('Invalid email').required('Required'),
});

async function performSubscribe(formValues: NewsletterFormValues): Promise<NewsletterResult> {
  const host = process.env.NEXT_PUBLIC_API_HOST || '/';
  const url = host + '/api/newsletters';

  const data = {
    email: formValues.email,
    client: 'penzu_web',
  };

  // debugger;

  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors', // no-cors, *cors, same-origin
    // credentials: 'same-origin', // include, *same-origin, omit
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });

  try {
    const result = await response.json();
    // debugger;
    if ((result as NewsletterResultError) || (result as NewsletterResultSuccess)) {
      return result;
    }
    throw new Error(`Bad response from server: ${JSON.stringify(result)}`);
  } catch (error) {
    // debugger;
    console.error('Unexpected error signing up: ', error);
    let message = 'There was an unexpected problem, try again later.';
    if (error instanceof Error) {
      message = error.message;
    }
    return {
      error: {
        title: 'Subscribe failed',
        message,
      },
    };
  }
}

export default function NewsletterFormSimple() {
  const [isSubscribed, setSubscribed] = useState<boolean>(false);
  return (
    <Formik
      initialValues={{
        base: '',
        email: '',
      }}
      validationSchema={NewsletterSchema}
      onSubmit={async (values, actions: FormikHelpers<NewsletterFormValues>) => {
        // console.log('onsubmit', values);
        const result = await performSubscribe(values);
        if ((result as NewsletterResultError).error) {
          actions.setSubmitting(false);
          const errorResult = result as NewsletterResultError;
          actions.setErrors({ base: errorResult.error.message });
        } else {
          // const successResult = result as NewsletterResultSuccess;
          setSubscribed(true);
          actions.setFieldValue('email', '');
          setTimeout(() => {
            actions.resetForm();
            setSubscribed(false);
          }, 3000);
        }
      }}
    >
      {({ isSubmitting, isValid, dirty, errors }) => (
        <Form>
          {errors.base && <div className="form-error">{errors.base}</div>}
          <div className="flex flex-col sm:flex-row justify-center max-w-xs mx-auto sm:max-w-md">
            <Field
              id="email"
              name="email"
              className="form-input w-full rounded-lg bg-white border border-neutral-200 focus:border-neutral-400 text-zinc-800 placeholder-neutral-400 mb-2 sm:mb-0 sm:mr-2"
              placeholder="Your email"
              aria-label="Your email…"
              autoComplete="email"
            />
            {isSubscribed ? (
              <div className="btn text-white bg-blue-500 hover:bg-blue-700 cursor-pointer">
                <span className="whitespace-nowrap">✓ Subscribed!</span>
              </div>
            ) : (
              <button
                type="submit"
                className="btn text-white bg-blue-500 hover:bg-blue-700"
                disabled={isSubmitting || !isValid || !dirty}
              >
                Subscribe
              </button>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}
